import type { GQMiscButtonsInput } from "graphql-sdk";
import type { ValidationSchema } from "../validation";

export const schemaMiscButton: ValidationSchema<GQMiscButtonsInput> = {
    name: { required: true },
};
